export default {"src":"/_next/static/media/google-workspace-logo.9fa3d7ab.svg","height":39,"width":305,"blurWidth":0,"blurHeight":0};